import { PageHeader } from "antd";
import LayoutCss from "../../../layout/layout.module.scss";
import { CandidateWorkflowContainer } from "./candidateWorkflowContainer/candidateWorkflowContainer";

export const CandidateWorkflow = () => {
  return (
    <>
      <PageHeader
        ghost={false}
        title="Candidate Workflow"
        className={LayoutCss.appPageHeader}
      />
      <CandidateWorkflowContainer />
    </>
  );
};
